export const ApiKey: string = 'maximumsourcing'